<template>
    <div class="wrapper-card">
        <div class="sidenav-wrapper" v-if="width > 1000">
            <SideNav
                :authedUser.sync="authedUser"
                :artistInfo.sync="artistInfo"
                :userInfo.sync="userInfo"
            />
        </div>
        <div class="content-wrapper">
            <EventManageHeader
                :counterOfferData.sync="counterOfferData"
                :mode="mode"
                :eventId="eventId"
                :eventIdInvite="eventIdInvite"
                :userId="parseInt(artistId)"
            />
            <CounterOffer
                :eventIdInvite="eventIdInvite"
                :userInfo="userInfo"
                :artistId="artistId"
                :counterOfferData="counterOfferData"
            />
        </div>
        <b-modal
            no-enforce-focus
            centered
            hide-header
            hide-footer
            id="modal-make-offer"
            size="l"
            tabindex=""
            content-class="modal-make-offer"
            no-close-on-backdrop
        >
            <div class="body-container">
                <div class="d-flex flex-column">
                    <p class="title-warning-message">It Looks Like Things Have Changed</p>
                    <p class="warning-message">
                        An artist is no longer needed for this event. But don’t worry, there
                        are are other other opportunities you may be a fit in your area.
                    </p>
                </div>
                <div class="btns-container">
                    <button @click="goToOpportunities" class="opportunities-btn">
                        See Opportunities
                    </button>
                    <p @click="goToBookingManager" class="return-btn">
                        Return to Booking Manager
                    </p>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import EventManageHeader from '../../booking-part/EventManageHeader.vue'
    import SideNav from '../../../parts/SideNav.vue'
    import CounterOffer from './CounterOffer.vue'
    import checkScreen from '../../../../mixins/check-screen'
    export default {
        name: 'ArtistEventPage',
        mixins: [checkScreen],
        props: {
            offerMode: {
                type: String,
                default: 'showAll'
            },
            bidArtist: {
                type: Number
            },
            counterOfferData: {
                type: Object
            },
            authedUser: {
                type: Boolean
            },
            artistInfo: {
                type: Object
            },
            userInfo: {
                type: Object
            },
            artistId: {
                type: Number
            }
        },
        components: {
            CounterOffer,
            SideNav,
            EventManageHeader
        },
        data() {
            return {
                eventId: null,
                mode: 'artistEvent',
                eventIdInvite: null
            }
        },
        methods: {
            goToOpportunities() {
                window.location.href = '/opportunities'
            },
            goToBookingManager() {
                window.location.href = '/booking-manager'
            }
        },
        watch: {
            'counterOfferData.status': function (status) {
                if (status === 2 && this.counterOfferData.event_artist_status === 3)
                    window.location.href = `/booking-manager/artist/advance/${this.artistId}`
                if (status > 2) this.$bvModal.show('modal-make-offer')
            },
            'counterOfferData.event_artist_status': function (artistStatus) {
                if (artistStatus > 3)
                    window.location.href = `/booking-manager/artist/advance/${this.artistId}`
            }
        },
        created() {
            this.eventId = localStorage.getItem('eventId')
            const url = window.location.href.split('/')
            if (url.length > 4) {
                this.eventIdInvite = window.location.href.split('/').pop()
            } else {
                this.eventIdInvite = ''
            }
        }
    }
</script>

<style>
    .modal-make-offer {
        min-width: 550px;
        border-radius: 15px;
        border: 1px solid rgba(255, 255, 255, 0.14);
        background: #262626;
        position: relative;
        min-height: 200px;
        padding: 48px 80px;
    }
</style>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .body-container {
        display: flex;
        flex-direction: column;
        gap: 48px;
    }
    .btns-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px;
    }
    .return-btn {
        color: #8b8b8b;
        text-align: center;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
        cursor: pointer;
    }
    .opportunities-btn {
        padding: 11px 30px 12px 30px;
        border-radius: 100px;
        background: #cdeb09;
        color: #000;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 650;
        line-height: 120%;
        width: 100%;
        border: 0;
    }
    .title-warning-message {
        color: #f5f5f5;
        text-align: center;
        font-family: 'Instrument Sans';
        font-size: 38px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .warning-message {
        color: #acacac;
        text-align: center;
        font-family: 'Instrument Sans';
        font-size: 14px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .content-wrapper {
        flex: 0 1 90%;
        max-width: 100%;
    }
    .wrapper-card {
        max-width: 100%;
        overflow: hidden;
    }
    .wrapper-card {
        display: flex;
        background: #000;
        align-items: flex-start;
        padding: 50px;
        gap: 58px;
    }
    .bottom-line-up {
        display: flex;
        flex-direction: row;
        border: 1px solid #646464;
        width: 90%;
        margin: 50px;
    }
    @media (max-width: 1000px) {
        .wrapper-card {
            padding: 0;
        }
        .content-wrapper {
            flex: 0 1 100%;
        }
    }
</style>
